import { render, staticRenderFns } from "./teaRights.vue?vue&type=template&id=cb524f04&scoped=true&"
import script from "./teaRights.vue?vue&type=script&lang=js&"
export * from "./teaRights.vue?vue&type=script&lang=js&"
import style0 from "./teaRights.vue?vue&type=style&index=0&id=cb524f04&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb524f04",
  null
  
)

export default component.exports